import biLogger from '@wix/web-bi-logger';
import { BISources } from '../consts/bi';

const logger = biLogger
  .factory({ endpoint: 'team' })
  .updateDefaults({
    src: BISources.myAccount,
    origin: 'account.team-management'
  })
  .logger();

export function sendBI(options: object) {
  return logger.log({
    _: Date.now(),
    ...options,
  });
}

const partnersLogger = biLogger
  .factory({ endpoint: 'expert-dashboard' })
  .updateDefaults({
    src: BISources.myAccount,
    origin: 'account.team-management'
  })
  .logger();

export function sendPartnersBI(options: object) {
  return partnersLogger.log({
    _: Date.now(),
    ...options,
  });
}

const dashLogger = biLogger
  .factory({ endpoint: 'dash' })
  .updateDefaults({
    src: BISources.myAccount,
    origin: 'account.team-management'
  })
  .logger();

export function sendDashBI(options: object) {
  return dashLogger.log({
    _: Date.now(),
    ...options,
  });
}
